import cn from 'bem-cn';

import { Stack } from '../../../../UI';

import { ChallengePrizeProps } from './ChallengePrize.types';
import './ChallengePrize.scss';

const b = cn('challenge-prize');

export const ChallengePrize = (props: ChallengePrizeProps) => {
    const { image, text } = props;

    return (
        <Stack className={b()} justifyContent="space-between">
            <img className={b('image')} src={image} alt="" />
            <p>{text}</p>
        </Stack>
    );
};
